<template>
  <div>
    <b-modal id="deleteQuestionModal" centered>
      <template #modal-header><h4>Usuwanie pytania</h4></template>
      Czy na pewno chcesz usunąć pytanie?
      <template #modal-footer>
        <vs-button type="border round" icon-pack="feather" icon="icon-x"
                   @click="$bvModal.hide('deleteQuestionModal')">
          Anuluj
        </vs-button>
        <vs-button color="danger" type="filled round" icon-pack="feather" icon="icon-trash"
                   @click="deleteQuestion(current_uuid)" class="mr-4">
          Usuń
        </vs-button>
      </template>
    </b-modal>
    <side-bar title="Dodaj pytanie" width="large" :visible="sideBarVisable">
      <b-container fluid class="px-4 py-3">
        <b-row>
          <b-col>
            <vs-input
              label="Pytanie"
              v-model="payload.content"
              class="w-100"
            />
            <field-error :errorsBag="formErrors" fieldName="content"/>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col cols="12">
            <p>Odpowiedzi</p>
          </b-col>
          <b-col v-for="(a, i) in payload.answers" cols="12" class="mb-3">
            <b-row>
              <b-col cols="7">
                <vs-input
                  label="Odpowiedź"
                  v-model="a.content"
                  type="text"
                  class="w-100"
                />
                <field-error :errorsBag="formErrors" :fieldName="`answers.${i}.content`" />
              </b-col>
              <b-col cols="3">
                <vs-input
                  label="Ilość punktów"
                  v-model="a.score"
                  type="number"
                  class="w-100"
                />
                <field-error :errorsBag="formErrors" :fieldName="`answers.${i}.score`" />
              </b-col>
              <b-col class="d-flex justify-content-center flex-column">
                <vs-button radius color="danger" class="m-0" type="flat" icon-pack="feather" icon="icon-x" @click="deleteAnswer(i)"></vs-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="mt-3">
            <vs-button radius type="flat" icon-pack="feather" icon="icon-plus" @click="addAnswer"></vs-button>
          </b-col>
        </b-row>
        <b-row class="mt-8">
          <b-col cols="3">
            <vs-button type="filled round" icon-pack="feather" icon="icon-plus" @click="createQuestion">Dodaj</vs-button>
          </b-col>
          <b-col>
            <vs-button class="ml-3" type="border round" @click="sideBarVisable=false">Anuluj</vs-button>
          </b-col>
        </b-row>
      </b-container>
    </side-bar>
    <b-container fluid>
      <b-row class="mb-6 mt-6">
        <b-col>
          <h4 class="mb-6">Pytania</h4>
        </b-col>
        <b-col>
          <vs-button type="border primary round" class="float-right" @click="sideBarVisable=true">Dodaj pytanie</vs-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="questions">
          <ul>
            <li v-for="q in questions" :key="q.uuid">
              <div class="flex justify-between w-100 mb-3">
                <vs-input type="text" placeholder="Treść pytania" class="w-100" v-model="q.content" disabled />
                <vs-button radius color="danger" type="flat" icon="close" class="ml-3" @click="openDeleteModal(q.uuid)"></vs-button>
              </div>
              <b-card v-if="q.answers" class="mb-4">
                <div class="mb-3 flex" v-for="a in q.answers" :key="a.uuid">
                  <vs-input type="text" placeholder="Treść odpowiedzi" v-model="a.content" disabled class="w-100 mr-3"/>
                  <vs-input type="number" v-model="a.score" disabled class="mr-3"/>
                </div>
              </b-card>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import axios from "axios"
import notification from "@/notification"
import FieldError from "@/components/wod/forms/FieldError"
import SideBar from "@/components/wod/SideBar"

export default {
  name: "ExamQuestions",
  components: {
    FieldError,
    draggable,
    SideBar
  },
  data () {
    return {
      questions: [],
      formErrors: {},
      sideBarVisable: false,
      payload: {
        content: null,
        answers: [
          {
            content: null,
            score: null
          }
        ]
      },
      current_uuid: null,
    }
  },
  computed: {
    uuid: function() {
      return this.$route.params.uuid
    },
  },
  mounted() {
   this.getExamQuestions(this.uuid)
  },
  methods: {
     addAnswer () {
      this.payload.answers.push({ content: null , score: null})
    },

    deleteAnswer (a) {
      this.payload.answers = this.payload.answers.filter((x, i) => i !== a)
    },

    // axios methods

    getExamQuestions() {
      this.$vs.loading()
      axios.get(`/ez/exams/${this.uuid}/exam-questions`)
        .then(response => { this.questions = response.data.data })
        .catch( error => {
          this.$vs.notify(notification.error(error))
        })
      .finally(() => {
        this.$vs.loading.close()
      })
    },

    createQuestion() {
        this.$vs.loading()
        axios.post(`/ez/exams/${this.uuid}/exam-questions`, this.payload)
          .then(() => {
            this.$vs.notify(notification.success('Pytanie zostało dodane'))
            this.sideBarVisable = false
            this.resetForm()
            this.getExamQuestions()
          })
          .catch( error => {
            if (error.response && error.response.status === 422) {
              this.formErrors = error.response.data.errors
            }
            else {
              this.$vs.notify(notification.error(error))
            }
          })
          .finally(() => {
            this.$vs.loading.close()
          })
      },

    deleteQuestion(uuid) {
       axios.delete(`/ez/exam-questions/${uuid}`)
      .then(() => {
        this.$vs.notify(notification.success('Pytanie zostało usunięte'))
        this.getExamQuestions(this.uuid)
      })
      .catch(error => {
        this.$vs.notify(notification.error(error))
      })
      .finally(() => {
        this.current_uuid = null
        this.$bvModal.hide('deleteQuestionModal')
      })
    },

    openDeleteModal(uuid) {
      this.current_uuid = uuid
      this.$bvModal.show('deleteQuestionModal')
    },

    resetForm() {
      this.payload= {
        content: null,
          answers: [
          {
            content: null,
            score: null
          }
        ]
      }
    },

  },
}
</script>

<style scoped>
</style>
